import { Facebook, Mail, Phone } from 'lucide-react'
import PageHero from '../components/PageHero'
import ContactForm from '../components/ContactForm'
import Reveal from '../components/Reveal'
import { site } from '../data/site'
import { useSeo } from '../hooks/useSeo'

export default function ContactPage() {
  useSeo({
    title: 'Contact | Em Whell Motorsport',
    description: 'Get in touch with Em Whell Motorsport for sponsorship, appearances, media and general racing enquiries.',
    path: '/contact',
  })

  return (
    <>
      {/* <PageHero eyebrow="Contact" title="Be part of" highlight="the journey." copy="For sponsorship, media, appearances, promotions and general racing enquiries." image="/assets/hero-action.jpg" /> */}
      <section className="section"><div className="site-container contact-page-grid"><Reveal><p className="eyebrow">Contact Em Whell Motorsport</p><h1>Let’s create something <span>memorable.</span></h1><p className="muted">Tell Em and the team about your business, event or idea. The form sends through the Cloudflare Pages Function once email delivery is configured.</p><div className="contact-cards"><a href={`mailto:${site.email}`}><Mail /><span><small>Email</small>{site.email}</span></a><a href={site.facebook} target="_blank" rel="noreferrer"><Facebook /><span><small>Social</small>Follow on Facebook</span></a></div></Reveal><Reveal><ContactForm /></Reveal></div></section>
    </>
  )
}
